import { render, staticRenderFns } from "./ItcSelect.vue?vue&type=template&id=8f02d6b8&scoped=true"
import script from "./ItcSelect.vue?vue&type=script&lang=js"
export * from "./ItcSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f02d6b8",
  null
  
)

export default component.exports